import React, { useState, useEffect } from 'react';
import {
  Container, Grid, Card, CardContent, Typography,
  Button, Box, Chip, Avatar, Alert, Dialog,
  DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { api } from '../services/api';

const MyConnections = () => {
  const [connections, setConnections] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [error, setError] = useState('');
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    fetchConnections();
    fetchPendingRequests();
  }, []);

  const fetchConnections = async () => {
    try {
      const response = await api.getBusinessConnections();
      setConnections(response);
    } catch (error) {
      setError('Error al cargar las conexiones');
    }
  };

  const fetchPendingRequests = async () => {
    try {
      const response = await api.getPendingConnections();
      setPendingRequests(response);
    } catch (error) {
      setError('Error al cargar las solicitudes pendientes');
    }
  };

  const handleRemoveConnection = async () => {
    try {
      await api.removeConnection(selectedConnection._id);
      setConnections(connections.filter(c => c._id !== selectedConnection._id));
      setOpenDialog(false);
    } catch (error) {
      setError('Error al eliminar la conexión');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Typography variant="h4" gutterBottom>
        Mis Conexiones
      </Typography>

      <Grid container spacing={3}>
        {connections.map((connection) => (
          <Grid item xs={12} sm={6} md={4} key={connection._id}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Avatar src={connection.distributor.logoUrl} sx={{ mr: 2 }} />
                  <Typography variant="h6">
                    {connection.distributor.name}
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {connection.distributor.description}
                </Typography>

                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() => {
                      setSelectedConnection(connection);
                      setOpenDialog(true);
                    }}
                  >
                    Eliminar Conexión
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {pendingRequests.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            Solicitudes Pendientes
          </Typography>
          <Grid container spacing={3}>
            {pendingRequests.map((request) => (
              <Grid item xs={12} sm={6} md={4} key={request._id}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {request.distributor.name}
                    </Typography>
                    <Chip
                      label="Pendiente"
                      color="warning"
                      size="small"
                      sx={{ mb: 2 }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de eliminar la conexión con {selectedConnection?.distributor.name}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>
            Cancelar
          </Button>
          <Button onClick={handleRemoveConnection} color="error">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default MyConnections; 